import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PanelProvider } from "@/panel/context";
import { panelRoutes } from "@/panel/routes";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <PanelProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            {panelRoutes()}
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="light" />
      </PanelProvider>
    </div>
  );
}

export default App;
